import { useEffect, useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { LangType } from '../../../../../../helpers/lang';
import { getValueFromOptions } from '../../../../../../helpers/mappers';
import { useLang } from '../../../../../../hooks/use-lang';
import { EmployeeType } from '../../../../../../store/api/employees-api';
import { useBranchesStore } from '../../../../../../store/use-branch-store';
import { useEmployeesStore } from '../../../../../../store/use-employee-store';
import { useTagStaffStore } from '../../../../../../store/use-tag-staff-store';
import { IdValue } from '../../../../../../types/props';

export const useCreateEmployeeModal = () => {
  const { postEmployee, isLoading, staff, putEmployee } = useEmployeesStore();
  const { fetchBranches, place } = useBranchesStore();
  const { fetchTags, tags } = useTagStaffStore();
  const [params] = useSearchParams();
  const id = params.get('id');

  const [employee, setEmployee] = useState<Partial<EmployeeType>>();

  useEffect(() => {
    setEmployee(staff?.find((item) => item.id === Number(id)));
  }, [id, staff]);

  const { getLocale, t } = useLang();

  const handleChangeName = (e: LangType) => {
    setEmployee((prev) => ({ ...prev, name: e }));
  };

  const handleChangeSurname = (e: LangType) => {
    setEmployee((prev) => ({ ...prev, surname: e }));
  };

  const handleChangeBranch = (ids: IdValue[]) => {
    const selectedBranches = place?.filter((item) =>
      ids.some((branch) => branch.id === String(item.id)),
    );
    const updatedBranches = selectedBranches?.map((item) => ({
      id: Number(item.id),
      value: item.name,
    }));
    setEmployee((prev) => ({ ...prev, places: updatedBranches }));
  };

  const handleChangeTags = (ids: IdValue[]) => {
    setEmployee((prev) => ({ ...prev, tags: ids }));
  };

  const branches: IdValue[] = useMemo(() => {
    return place?.map((item) => ({ id: String(item.id), value: getLocale(item.name) })) || [];
  }, [getLocale, place]);

  const selectedTags = getValueFromOptions(
    tags,
    employee?.tags?.map((item) => item.id),
  );

  const selectedBranches = getValueFromOptions(
    branches,
    employee?.places?.map((item) => item.id),
  );

  useEffect(() => {
    fetchBranches({ n: 100, since_id: 0, customCache: true });
    fetchTags({ is_by_company: true, n: 1000, since_id: 0 });
  }, [fetchBranches, fetchTags]);

  return {
    employee,
    handleChangeName,
    handleChangeSurname,
    handleChangeBranch,
    handleChangeTags,
    isLoading,
    postEmployee,
    putEmployee,
    setEmployee,
    branches,
    tags,
    selectedTags,
    selectedBranches,
    t,
  };
};
